module.exports = __webpack_public_path__ + "media/images/screen-capture-a4bc5a529ce43a9eec674e56626b787f.png";